import React, { useState, useEffect } from 'react';
import { useStateContext } from '../context/StateContext';

const QStashTest = () => {
    const [status, setStatus] = useState('Ready');
    const [messageId, setMessageId] = useState(null);
    const [polling, setPolling] = useState(false);
    const {apiUrl, hideTestButtons} = useStateContext();

    // Cleanup polling on unmount
    useEffect(() => {
        return () => {
            setPolling(false);
        };
    }, []);

    const pollStatus = async (id) => {
        setPolling(true);
        let pollInterval;

        const poll = async () => {
            try {
                // Use the correct endpoint for the test QStash status
                const response = await fetch(`${apiUrl}/api/qstash/status/${id}`);
                const data = await response.json();

                if (data.error) {
                    setStatus(`Error: ${data.error}`);
                    clearInterval(pollInterval);
                    setPolling(false);
                    return;
                }

                if (data.completed) {
                    setStatus(`Completed!\n\nResponse: ${JSON.stringify(data.response, null, 2)}`);
                    clearInterval(pollInterval);
                    setPolling(false);
                }
            } catch (error) {
                process.env.NODE_ENV === "development" && console.error('Error polling status:', error);
                setStatus(`Error polling status: ${error.message}`);
                clearInterval(pollInterval);
                setPolling(false);
            }
        };

        // Do initial poll immediately
        await poll();
        
        // Then start polling interval
        pollInterval = setInterval(poll, 1000);

        // Cleanup function
        return () => {
            if (pollInterval) {
                clearInterval(pollInterval);
            }
            setPolling(false);
        };
    };

    const sendRequest = async () => {
        setStatus('Sending request...');
        try {
            const response = await fetch(`${apiUrl}/api/qstash/process`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            setMessageId(data.messageId);
            setStatus(`Request sent successfully!\n\nMessage ID: ${data.messageId}\nWaiting for response...`);
            
            // Start polling for status
            pollStatus(data.messageId);
        } catch (error) {
            setStatus(`Error: ${error.message}`);
        }
    };

    return (
        <div style={{ maxWidth: '800px', margin: '40px auto', padding: '20px' }}>
            <h1>QStash Test</h1>
            <p>Click the button to send a request to be processed by QStash</p>
            
            <button 
                onClick={sendRequest}
                disabled={polling}
                style={{
                    padding: '10px 20px',
                    fontSize: '16px',
                    cursor: polling ? 'not-allowed' : 'pointer',
                    backgroundColor: polling ? '#cccccc' : '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px'
                }}
            >
                {polling ? 'Processing...' : 'Send Request'}
            </button>

            <div style={{
                marginTop: '20px',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                minHeight: '100px',
                whiteSpace: 'pre-wrap',
                fontFamily: 'monospace'
            }}>
                {status}
            </div>
        </div>
    );
};

export default QStashTest;
